import "./ConfirmationDialog.scss";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import { ReactComponent as CloseIcon } from "../../../assets/svg/closeicon.svg";
import React, { type ReactNode } from "react"; // eslint-disable-line

interface ConfirmationDialogProps {
  open: boolean;
  title?: string;
  contentBody: ReactNode;
  confirmButtonName?: string;
  cancelButtonName?: string;
  okButtonName?: string;
  okButtonDisabled?: boolean;
  cancelOnClose?: boolean;
  confirmButtonClassName?: string;
  confirmButtonDisabled?: boolean;
  cancelButtonClassName?: string;
  okButtonClassName?: string;
  dialogClassName?: string;
  isAlertConfirmation?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  onOk?: () => void;
  onClose?: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = "",
  contentBody,
  confirmButtonName,
  cancelButtonName,
  okButtonName,
  confirmButtonClassName,
  cancelButtonClassName,
  okButtonClassName,
  okButtonDisabled,
  dialogClassName,
  confirmButtonDisabled,
  isAlertConfirmation,
  onConfirm,
  onCancel,
  onOk,
  onClose,
}) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onCancel != null && onCancel();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`${dialogClassName} dialog-box`}
      >
        {title ?? (
          <DialogTitle id="alert-dialog-title" className="dialog-title">
            {title}
          </DialogTitle>
        )}
        <IconButton
          aria-label="close"
          onClick={onClose ?? onCancel}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          className={`dialog-content ${isAlertConfirmation && "alert-wrapper"}`}
        >
          <div className="dialog-content-text">{contentBody}</div>
        </DialogContent>
        <DialogActions className="dialog-actions">
          {onOk != null ? (
            <div className="d-flex justify-content-center w-100">
              {onOk != null && (
                <Button
                  variant="contained"
                  onClick={onOk}
                  autoFocus
                  className={okButtonClassName}
                  disabled={okButtonDisabled}
                >
                  {okButtonName ?? "Ok"}
                </Button>
              )}
            </div>
          ) : (
            <div className="d-flex justify-content-end gap-5 w-100">
              {onCancel != null && (
                <Button
                  variant="outlined"
                  onClick={onCancel}
                  className={cancelButtonClassName}
                >
                  {cancelButtonName ?? "Cancel"}
                </Button>
              )}
              {onConfirm != null && (
                <Button
                  variant="contained"
                  onClick={onConfirm}
                  className={confirmButtonClassName}
                  disabled={confirmButtonDisabled}
                >
                  {confirmButtonName ?? "Confirm"}
                </Button>
              )}
            </div>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationDialog;
